<script>
    import Layout from "../../layouts/main";
    import appConfig from "@/app.config";
    import Content from '@/services/Content'

    export default {
        components: { Layout },
        page: {
            title: "Create Post",
            meta: [
                {
                    name: "description",
                    content: appConfig.description,
                },
            ],
        },
        data() {
            return {
                title: "Create Post",
                items: [
                    {
                        text: "Social Upload",
                        href: "/content/social_upload",
                    },
                    {
                        text: "Create Post",
                        active: true,
                    },
                ],
                // Profile / connection state
                username: process.env.VUE_APP_TENANT || "",
                profile: {},
                loadingProfile: false,
                profileError: null,
                isConnecting: false,
                // Connected social accounts
                socialAccounts: [],
                loadingSocialAccounts: true,
                // Facebook pages
                facebookPages: [],
                loadingFacebookPages: false,
                // LinkedIn pages
                linkedinPages: [],
                loadingLinkedinPages: false,
                // Composer state
                postType: "text",
                postTypes: [
                    { value: "text", label: "Text", icon: "mdi mdi-format-text" },
                    { value: "photos", label: "Photos", icon: "mdi mdi-image-multiple" },
                    { value: "video", label: "Video", icon: "mdi mdi-video" },
                ],
                knownPlatforms: [
                    { key: "instagram", label: "Instagram", icon: "mdi mdi-instagram" },
                    { key: "tiktok", label: "TikTok", icon: "mdi mdi-music-note" },
                    { key: "x", label: "X (Twitter)", icon: "mdi mdi-twitter" },
                    { key: "facebook", label: "Facebook", icon: "mdi mdi-facebook" },
                    { key: "youtube", label: "YouTube", icon: "mdi mdi-youtube" },
                    { key: "linkedin", label: "LinkedIn", icon: "mdi mdi-linkedin" },
                ],
                isPublishing: false,
                scheduleType: "immediately",
                // Which platform the preview pane is mimicking.
                previewPlatform: "instagram",
                // Post history
                history: [],
                loadingHistory: false,
                selectedHistoryItem: null,
                historyCurrentPage: 1,
                historyPerPage: 10,
                historyFields: [
                    { key: "timestamp", label: "Date" },
                    { key: "scheduled_date", label: "Scheduled" },
                    { key: "action_type", label: "Type" },
                    { key: "content", label: "Content" },
                    { key: "status", label: "Status" },
                    { key: "platforms", label: "Platforms" },
                    { key: "action", label: "Action" },
                ],
                // File upload UI state
                photoDragOver: false,
                videoDragOver: false,
                photoPreviews: [],
                photoDimensions: [],
                videoPreviewUrl: null,
                videoMeta: null,
                // Per-platform photo requirements (upload-post docs). Only the
                // platforms we offer for photos; constraints apply when selected.
                // ratio = width / height. TikTok photo mode wants portrait (≤ 1:1);
                // upload-post doesn't publish exact numbers, so these are tunable.
                photoPlatformRules: {
                    instagram: {
                        formats: ["image/png", "image/jpeg", "image/gif"],
                        display: "PNG, JPG or GIF",
                    },
                    tiktok: {
                        formats: ["image/jpeg", "image/webp"],
                        minWidth: 360,
                        minHeight: 360,
                        minRatio: 9 / 16, // 0.5625 — not taller than 9:16
                        maxRatio: 1,      // not wider than square (no landscape)
                        display: "JPG, JPEG or WEBP · portrait or square (9:16 to 1:1, no landscape) · min 360×360",
                    },
                    facebook: {
                        formats: ["image/jpeg", "image/png", "image/gif", "image/webp"],
                        display: "JPG, PNG, GIF or WebP",
                    },
                    x: {
                        formats: ["image/jpeg", "image/png", "image/gif", "image/webp"],
                        maxSizeMB: 5,
                        maxCount: 4,
                        display: "JPG, PNG, GIF or WebP · up to 5 MB each · max 4 photos",
                    },
                },
                // Per-platform video requirements (upload-post docs). Constraints
                // apply when the platform is selected; `display` drives the UI note.
                videoPlatformRules: {
                    instagram: {
                        formats: ["video/mp4", "video/quicktime"],
                        maxSizeMB: 300, minDuration: 3, maxDuration: 900,
                        display: "MP4 or MOV · up to 300 MB · 3 s–15 min",
                    },
                    tiktok: {
                        formats: ["video/mp4", "video/webm", "video/quicktime"],
                        maxSizeMB: 4096, maxDuration: 600, minWidth: 360, minHeight: 360,
                        display: "MP4, WebM or MOV · up to 4 GB · ≤ 10 min · min 360×360",
                    },
                    facebook: {
                        formats: ["video/mp4", "video/quicktime"],
                        minDuration: 3, maxDuration: 90,
                        display: "MP4 or MOV · 3–90 s (posted as a Reel)",
                    },
                    x: {
                        formats: ["video/mp4"],
                        maxSizeMB: 1024, minDuration: 0.5, maxDuration: 14400, minRatio: 1 / 3, maxRatio: 3,
                        display: "MP4 · up to 1 GB · 0.5 s–4 h · aspect 1:3 to 3:1",
                    },
                    youtube: {
                        display: "Most video formats · up to 256 GB",
                    },
                },
                form: {
                    platforms: [],
                    facebook_page_id: "",
                    target_linkedin_page_id: "",
                    title: "",
                    description: "",
                    link_url: "",
                    scheduled_date: "",
                    photos: [],
                    video: null,
                },
              logo_image:"https://stadiaconnect-cdn.s3.eu-west-1.amazonaws.com/psv/img/sponsor/azerion_emblem.png",
            };
        },
        computed: {
            availablePlatforms() {
                const byPlatform = {};
                (this.socialAccounts || []).forEach(a => { byPlatform[a.platform] = a; });
                const list = this.knownPlatforms.map(p => ({
                    ...p,
                    connected: !!byPlatform[p.key],
                    account: byPlatform[p.key] || null,
                }));
                // Include any connected platform we don't know about.
                Object.keys(byPlatform).forEach(key => {
                    if (!this.knownPlatforms.some(p => p.key === key)) {
                        list.push({
                            key,
                            label: key.charAt(0).toUpperCase() + key.slice(1),
                            icon: "mdi mdi-share-variant",
                            connected: true,
                            account: byPlatform[key],
                        });
                    }
                });
                // platforms hidden for now
                const hidden = ["linkedin"];
                return list.filter(p => !hidden.includes(p.key));
            },
            visiblePlatforms() {
                // platforms that each post type can't target
                const excluded = {
                    text: ["instagram", "tiktok", "youtube"],
                    photos: ["youtube", "tiktok"],
                    video: [],
                };
                const hidden = excluded[this.postType] || [];
                return this.availablePlatforms.filter(p => !hidden.includes(p.key));
            },
            connectedPlatforms() {
                return this.visiblePlatforms.filter(p => p.connected);
            },
            needsFacebookPage() {
                return this.form.platforms.includes("facebook");
            },
            needsLinkedinPage() {
                return this.form.platforms.includes("linkedin");
            },
            facebookVideoCaption() {
                // For Facebook video (posted as a Reel) the caption is the description, not the content.
                return this.postType === "video" && this.form.platforms.includes("facebook");
            },
            profileName() {
                return this.profile.username || this.username || "Your page";
            },
            avatarInitials() {
                return this.profileName.slice(0, 2).toUpperCase();
            },
            // Per-platform requirement lines shown to the user for photo posts.
            photoRequirements() {
                const labels = { instagram: "Instagram", tiktok: "TikTok", x: "X (Twitter)", facebook: "Facebook" };
                return this.form.platforms
                    .filter(p => this.photoPlatformRules[p] && this.photoPlatformRules[p].display)
                    .map(p => ({ platform: p, label: labels[p] || p, display: this.photoPlatformRules[p].display }));
            },
            showDescription() {
                // the platforms that actually read the description differ per post type
                if (this.postType === "text") return false;
                const platformsUsingDescription = this.postType === "video"
                    ? ["youtube", "facebook", "linkedin"]
                    : ["tiktok", "linkedin"]; // photos
                return this.form.platforms.some(p => platformsUsingDescription.includes(p));
            },
            descriptionHint() {
                if (this.postType === "video") {
                    return "Optional extended text used only on LinkedIn commentary, Facebook descriptions, YouTube descriptions, and Pinterest notes. Ignored elsewhere.";
                }
                if (this.postType === "photos") {
                    return "Optional extended text used on TikTok photo descriptions, LinkedIn commentary, Pinterest notes, and Reddit bodies. On Facebook the photo caption comes from the Content field, not here. Ignored elsewhere.";
                }
                return "";
            },
            // Photo constraints derived from the currently selected platforms.
            photoConstraints() {
                const selected = this.form.platforms.filter(p => this.photoPlatformRules[p]);
                let allowedTypes = null; // null = no restriction
                let maxSizeMB = Infinity;
                let maxCount = Infinity;
                let minWidth = 0;
                let minHeight = 0;
                let minRatio = 0;
                let maxRatio = Infinity;
                selected.forEach(key => {
                    const rule = this.photoPlatformRules[key];
                    if (rule.formats) {
                        allowedTypes = allowedTypes === null
                            ? rule.formats.slice()
                            : allowedTypes.filter(f => rule.formats.includes(f));
                    }
                    if (rule.maxSizeMB) maxSizeMB = Math.min(maxSizeMB, rule.maxSizeMB);
                    if (rule.maxCount) maxCount = Math.min(maxCount, rule.maxCount);
                    if (rule.minWidth) minWidth = Math.max(minWidth, rule.minWidth);
                    if (rule.minHeight) minHeight = Math.max(minHeight, rule.minHeight);
                    if (rule.minRatio) minRatio = Math.max(minRatio, rule.minRatio);
                    if (rule.maxRatio) maxRatio = Math.min(maxRatio, rule.maxRatio);
                });
                return { allowedTypes, maxSizeMB, maxCount, minWidth, minHeight, minRatio, maxRatio };
            },
            allowedFormatsLabel() {
                const types = this.photoConstraints.allowedTypes;
                if (!types) return "";
                const map = { "image/jpeg": "JPG", "image/png": "PNG", "image/gif": "GIF", "image/webp": "WEBP" };
                return types.map(t => map[t] || t).join(", ");
            },
            photoAccept() {
                const types = this.photoConstraints.allowedTypes;
                return (types && types.length) ? types.join(",") : "image/*";
            },
            photoHint() {
                const c = this.photoConstraints;
                const parts = [this.allowedFormatsLabel || "PNG, JPG, GIF"];
                if (Number.isFinite(c.maxSizeMB)) parts.push(`max ${c.maxSizeMB} MB each`);
                if (Number.isFinite(c.maxCount)) parts.push(`up to ${c.maxCount} photos`);
                return parts.join(" · ");
            },
            // Video constraints derived from the currently selected platforms.
            videoConstraints() {
                const selected = this.form.platforms.filter(p => this.videoPlatformRules[p]);
                let allowedTypes = null;
                let maxSizeMB = Infinity;
                let minDuration = 0;
                let maxDuration = Infinity;
                let minWidth = 0;
                let minHeight = 0;
                let minRatio = 0;
                let maxRatio = Infinity;
                selected.forEach(key => {
                    const rule = this.videoPlatformRules[key];
                    if (rule.formats) {
                        allowedTypes = allowedTypes === null
                            ? rule.formats.slice()
                            : allowedTypes.filter(f => rule.formats.includes(f));
                    }
                    if (rule.maxSizeMB) maxSizeMB = Math.min(maxSizeMB, rule.maxSizeMB);
                    if (rule.minDuration) minDuration = Math.max(minDuration, rule.minDuration);
                    if (rule.maxDuration) maxDuration = Math.min(maxDuration, rule.maxDuration);
                    if (rule.minWidth) minWidth = Math.max(minWidth, rule.minWidth);
                    if (rule.minHeight) minHeight = Math.max(minHeight, rule.minHeight);
                    if (rule.minRatio) minRatio = Math.max(minRatio, rule.minRatio);
                    if (rule.maxRatio) maxRatio = Math.min(maxRatio, rule.maxRatio);
                });
                return { allowedTypes, maxSizeMB, minDuration, maxDuration, minWidth, minHeight, minRatio, maxRatio };
            },
            videoFormatsLabel() {
                const types = this.videoConstraints.allowedTypes;
                if (!types) return "";
                const map = { "video/mp4": "MP4", "video/quicktime": "MOV", "video/webm": "WebM" };
                return types.map(t => map[t] || t).join(", ");
            },
            videoAccept() {
                const types = this.videoConstraints.allowedTypes;
                return (types && types.length) ? types.join(",") : "video/*";
            },
            videoHint() {
                const c = this.videoConstraints;
                const parts = [this.videoFormatsLabel || "MP4, MOV"];
                if (Number.isFinite(c.maxSizeMB)) parts.push(`max ${this.sizeLabel(c.maxSizeMB)}`);
                return parts.join(" · ");
            },
            // Per-platform requirement lines shown to the user for video posts.
            videoRequirements() {
                const labels = { instagram: "Instagram", tiktok: "TikTok", x: "X (Twitter)", facebook: "Facebook", youtube: "YouTube" };
                return this.form.platforms
                    .filter(p => this.videoPlatformRules[p] && this.videoPlatformRules[p].display)
                    .map(p => ({ platform: p, label: labels[p] || p, display: this.videoPlatformRules[p].display }));
            },
            // Platforms offered as preview tabs — only the connected ones valid
            // for the current post type.
            previewPlatforms() {
                return this.connectedPlatforms;
            },
            // Caption text shown inside every platform mock.
            captionText() {
                return this.form.title || "Your post preview will appear here.";
            },
            // @handle used by the X / TikTok mocks.
            handle() {
                return (this.profileName || "yourpage").toLowerCase().replace(/\s+/g, "");
            },
            // Media rendered in the preview, derived from the current post type.
            previewImageUrl() {
                return (this.postType === "photos" && this.photoPreviews.length) ? this.photoPreviews[0] : "";
            },
            previewVideoUrl() {
                return (this.postType === "video" && this.videoPreviewUrl) ? this.videoPreviewUrl : "";
            },
        },
        watch: {
            "form.platforms"(val) {
                if (val.includes("facebook") && !this.facebookPages.length) {
                    this.loadFacebookPages();
                }
                if (val.includes("linkedin") && !this.linkedinPages.length) {
                    this.loadLinkedinPages();
                }
            },
            postType() {
                // drop any selected platforms the current post type doesn't support
                const allowed = this.visiblePlatforms.map(p => p.key);
                this.form.platforms = this.form.platforms.filter(p => allowed.includes(p));
            },
            scheduleType(val) {
                if (val === "immediately") this.form.scheduled_date = "";
            },
            // Keep the preview on a connected platform valid for the post type.
            connectedPlatforms(list) {
                if (list.length && !list.some(p => p.key === this.previewPlatform)) {
                    this.previewPlatform = list[0].key;
                }
            },
        },
        async created() {
            // returning from the connect/management screen: persist the accounts
            if (this.$route.query.upload_post) {
                await this.saveSocialAccounts();
                // drop the marker so a refresh doesn't re-trigger the save
                const query = { ...this.$route.query };
                delete query.upload_post;
                this.$router.replace({ query }).catch(() => {});
            }
            this.loadSocialAccounts();
        },
        methods: {
            togglePlatform(p) {
                if (!p.connected) return;
                const i = this.form.platforms.indexOf(p.key);
                if (i === -1) {
                    this.form.platforms.push(p.key);
                } else {
                    this.form.platforms.splice(i, 1);
                }
            },
            async loadSocialAccounts() {
                this.loadingSocialAccounts = true;
                try {
                    const response = await Content.getSocialAccounts();
                    this.socialAccounts = response.data.data || [];
                } catch (error) {
                    this.socialAccounts = [];
                    this.failedmsg("Connected accounts", this.parseError(error));
                } finally {
                    this.loadingSocialAccounts = false;
                }
            },

            async saveSocialAccounts() {
                try {
                    await Content.saveSocialAccounts();
                } catch (error) {
                    this.failedmsg("Save accounts", this.parseError(error));
                }
            },

            parseError(error) {
                const e = error && error.response && error.response.data ? error.response.data.error : null;
                if (Array.isArray(e)) {
                    return e.join("<br>");
                }
                return e || "Something went wrong. Please try again.";
            },

            async loadProfile() {
                this.loadingProfile = true;
                this.profileError = null;
                try {
                    const response = await Content.getUploadPostProfile(this.username);
                    this.profile = response.data.data || {};
                } catch (error) {
                    this.profile = {};
                    this.profileError = this.parseError(error);
                } finally {
                    this.loadingProfile = false;
                }
            },

            async connectAccounts() {
                this.isConnecting = true;
                try {
                    // bring the user back to this page with a marker so we can
                    // persist the connected accounts on return
                    const redirectUrl = new URL(window.location.href);
                    redirectUrl.searchParams.set("upload_post", "1");
                    const response = await Content.uploadPostConnectSocials({
                        username: this.username,
                        redirect_url: redirectUrl.href,
                        redirect_button_text: "Go Back",
                        language: "nl",
                        logo_image: this.logo_image,
                        platforms: this.knownPlatforms.map(p => p.key),
                    });
                    const url = response.data.data ? response.data.data.access_url : null;
                    if (url) {
                        // navigate the current tab (avoids popup blockers); redirect_url returns the user here
                        window.location.href = url;
                    } else {
                        this.failedmsg("Connect accounts", "No connection URL was returned.");
                    }
                } catch (error) {
                    this.failedmsg("Connect accounts", this.parseError(error));
                } finally {
                    this.isConnecting = false;
                }
            },

            async loadFacebookPages() {
                this.loadingFacebookPages = true;
                try {
                    const response = await Content.getUploadPostFacebookPages();
                    this.facebookPages = (response.data.data && response.data.data.pages) ? response.data.data.pages : [];
                } catch (error) {
                    this.facebookPages = [];
                    this.failedmsg("Facebook Pages", this.parseError(error));
                } finally {
                    this.loadingFacebookPages = false;
                }
            },

            async loadHistory() {
                this.loadingHistory = true;
                try {
                    const response = await Content.getUploadPostHistory();
                    const items = response.data.data || [];
                    // newest first
                    this.history = items.slice().sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
                } catch (error) {
                    this.history = [];
                    this.failedmsg("Post history", this.parseError(error));
                } finally {
                    this.loadingHistory = false;
                }
            },

            // The history endpoint returns two meta_data shapes: an older one where
            // results is a platform-keyed object, and a newer one where results is
            // an array of per-platform objects. Normalize both to one list.
            historyResults(item) {
                const results = item && item.meta_data ? item.meta_data.results : null;
                if (Array.isArray(results)) {
                    return results.map(r => ({
                        platform: r.platform,
                        url: r.post_url,
                        success: r.success,
                        status: r.status ? r.status : (r.success ? "completed" : "failed"),
                        error: r.error_message,
                    }));
                }
                if (results && typeof results === "object") {
                    return Object.keys(results).map(platform => ({
                        platform,
                        url: results[platform].url,
                        success: results[platform].success,
                        status: results[platform].status || (results[platform].success ? "completed" : "failed"),
                        error: results[platform].error,
                    }));
                }
                return [];
            },
            historyStatus(item) {
                const meta = item && item.meta_data ? item.meta_data : {};
                return meta.status || (meta.success ? "completed" : "");
            },
            statusBadgeClass(status) {
                if (status === "completed") return "bg-success";
                if (status === "failed") return "bg-danger";
                return "bg-secondary";
            },
            platformIcon(platform) {
                const p = this.knownPlatforms.find(k => k.key === platform);
                return p ? p.icon : "mdi mdi-share-variant";
            },
            viewPostDetails(item) {
                this.selectedHistoryItem = item;
                this.$bvModal.show("view_post_details");
            },

            async loadLinkedinPages() {
                this.loadingLinkedinPages = true;
                try {
                    const response = await Content.getUploadPostLinkedinPages();
                    this.linkedinPages = (response.data.data && response.data.data.pages) ? response.data.data.pages : [];
                } catch (error) {
                    this.linkedinPages = [];
                    this.failedmsg("LinkedIn Pages", this.parseError(error));
                } finally {
                    this.loadingLinkedinPages = false;
                }
            },

            buildFormData() {
                const fd = new FormData();
                // platforms are sent as a JSON-encoded string in platform[0]
                fd.append("platform[0]", JSON.stringify(this.form.platforms));
                if (this.form.title) fd.append("title", this.form.title);
                // optional extended text, only when the description field is shown
                if (this.showDescription && this.form.description) fd.append("description", this.form.description);
                if (this.needsFacebookPage && this.form.facebook_page_id) {
                    fd.append("facebook_page_id", this.form.facebook_page_id);
                }
                // optional: post to a LinkedIn organization page (else the user's profile)
                if (this.needsLinkedinPage && this.form.target_linkedin_page_id) {
                    fd.append("target_linkedin_page_id", this.form.target_linkedin_page_id);
                }
                if (this.form.scheduled_date) {
                    fd.append("scheduled_date", new Date(this.form.scheduled_date).toISOString());
                }
                // fd.append('async_upload',true);
                return fd;
            },

            async publish() {
                // Validation
                if (!this.form.platforms.length) {
                    this.failedmsg("Select a platform", "Choose at least one connected platform to publish to.");
                    return;
                }
                if (this.needsFacebookPage && !this.form.facebook_page_id) {
                    this.failedmsg("Facebook Page required", "Select a Facebook Page to publish to Facebook.");
                    return;
                }
                if (this.postType === "text" && !this.form.title) {
                    this.failedmsg("Text required", "Enter the post text / caption.");
                    return;
                }
                if (this.postType === "photos" && (!this.form.photos || !this.form.photos.length)) {
                    this.failedmsg("Photos required", "Add at least one photo to publish.");
                    return;
                }
                if (this.postType === "photos" && !this.validatePhotos()) {
                    return;
                }
                if (this.postType === "video" && !this.form.video) {
                    this.failedmsg("Video required", "Add a video file to publish.");
                    return;
                }
                if (this.postType === "video" && !this.validateVideo()) {
                    return;
                }

                this.isPublishing = true;
                try {
                    let response;
                    if (this.postType === "text") {
                        const fd = this.buildFormData();
                        if (this.form.link_url) fd.append("link_url", this.form.link_url);
                        response = await Content.uploadPostUploadText(fd);
                    } else if (this.postType === "photos") {
                        const fd = this.buildFormData();
                        Array.from(this.form.photos).forEach(file => fd.append("photos[]", file));
                        response = await Content.uploadPostUploadPhotos(fd);
                    } else {
                        const fd = this.buildFormData();
                        fd.append("video", this.form.video);
                        response = await Content.uploadPostUploadVideo(fd);
                    }

                    if (response && response.data && response.data.data) {
                        this.successmsg("Post submitted", "Your post has been sent to the selected platforms.");
                        this.resetForm();
                    } else {
                        this.failedmsg("Publish failed", "Unexpected response from the server.");
                    }
                } catch (error) {
                    this.failedmsg("Publish failed", this.parseError(error));
                } finally {
                    this.isPublishing = false;
                }
            },

            // ----- File upload helpers -----
            triggerInput(ref) {
                this.$refs[ref].click();
            },

            readImageSize(url) {
                return new Promise(resolve => {
                    const img = new Image();
                    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
                    img.onerror = () => resolve({ width: 0, height: 0 });
                    img.src = url;
                });
            },
            // Returns a reason string when the dimensions break a constraint, else "".
            checkPhotoDimensions(dims, c) {
                const { width, height } = dims;
                if (!width || !height) return ""; // couldn't read — don't block
                if (c.minWidth && width < c.minWidth) {
                    return `image must be at least ${c.minWidth}px wide (is ${width}px)`;
                }
                if (c.minHeight && height < c.minHeight) {
                    return `image must be at least ${c.minHeight}px tall (is ${height}px)`;
                }
                const ratio = width / height;
                if (c.minRatio && ratio < c.minRatio - 0.01) {
                    return `aspect ratio ${ratio.toFixed(2)} is too tall for the selected platforms`;
                }
                if (c.maxRatio && Number.isFinite(c.maxRatio) && ratio > c.maxRatio + 0.01) {
                    return `aspect ratio ${ratio.toFixed(2)} is too wide for the selected platforms`;
                }
                return "";
            },
            async addPhotos(fileList) {
                const c = this.photoConstraints;
                const files = Array.from(fileList).filter(file => file.type.startsWith("image/"));
                for (const file of files) {
                    if (c.allowedTypes && !c.allowedTypes.includes(file.type)) {
                        this.failedmsg("Unsupported format", `${file.name} isn't accepted by the selected platforms. Allowed: ${this.allowedFormatsLabel}.`);
                        continue;
                    }
                    if (file.size > c.maxSizeMB * 1024 * 1024) {
                        this.failedmsg("Photo too large", `${file.name} is ${this.formatBytes(file.size)}. Max ${c.maxSizeMB} MB each for the selected platforms.`);
                        continue;
                    }
                    if (this.form.photos.length >= c.maxCount) {
                        this.failedmsg("Too many photos", `The selected platforms allow at most ${c.maxCount} photos.`);
                        break;
                    }
                    const url = URL.createObjectURL(file);
                    const dims = await this.readImageSize(url);
                    const reason = this.checkPhotoDimensions(dims, c);
                    if (reason) {
                        URL.revokeObjectURL(url);
                        this.failedmsg("Unsupported image", `${file.name}: ${reason}.`);
                        continue;
                    }
                    this.form.photos.push(file);
                    this.photoPreviews.push(url);
                    this.photoDimensions.push(dims);
                }
            },
            // Re-check photos at publish time, since the platform selection (and
            // therefore the limits) can change after photos were added.
            validatePhotos() {
                const c = this.photoConstraints;
                if (this.form.photos.length > c.maxCount) {
                    this.failedmsg("Too many photos", `The selected platforms allow at most ${c.maxCount} photos.`);
                    return false;
                }
                for (let i = 0; i < this.form.photos.length; i++) {
                    const file = this.form.photos[i];
                    if (c.allowedTypes && !c.allowedTypes.includes(file.type)) {
                        this.failedmsg("Unsupported format", `${file.name} isn't accepted by the selected platforms. Allowed: ${this.allowedFormatsLabel}.`);
                        return false;
                    }
                    if (file.size > c.maxSizeMB * 1024 * 1024) {
                        this.failedmsg("Photo too large", `${file.name} exceeds the ${c.maxSizeMB} MB limit for the selected platforms.`);
                        return false;
                    }
                    const reason = this.checkPhotoDimensions(this.photoDimensions[i] || {}, c);
                    if (reason) {
                        this.failedmsg("Unsupported image", `${file.name}: ${reason}.`);
                        return false;
                    }
                }
                return true;
            },
            onPhotosSelected(event) {
                this.addPhotos(event.target.files);
                event.target.value = ""; // allow re-selecting the same file
            },
            onPhotosDrop(event) {
                this.photoDragOver = false;
                if (event.dataTransfer && event.dataTransfer.files) {
                    this.addPhotos(event.dataTransfer.files);
                }
            },
            removePhoto(index) {
                URL.revokeObjectURL(this.photoPreviews[index]);
                this.photoPreviews.splice(index, 1);
                this.form.photos.splice(index, 1);
                this.photoDimensions.splice(index, 1);
            },

            sizeLabel(mb) {
                if (!Number.isFinite(mb)) return "";
                return mb >= 1024 ? `${(mb / 1024)} GB` : `${mb} MB`;
            },
            readVideoMeta(url) {
                return new Promise(resolve => {
                    const video = document.createElement("video");
                    video.preload = "metadata";
                    video.onloadedmetadata = () => resolve({
                        duration: video.duration,
                        width: video.videoWidth,
                        height: video.videoHeight,
                    });
                    video.onerror = () => resolve({ duration: 0, width: 0, height: 0 });
                    video.src = url;
                });
            },
            // Returns a reason string when the video breaks a constraint, else "".
            checkVideoMeta(meta, c) {
                if (meta.duration) {
                    if (c.minDuration && meta.duration < c.minDuration) {
                        return `video is too short (${meta.duration.toFixed(1)}s, min ${c.minDuration}s)`;
                    }
                    if (Number.isFinite(c.maxDuration) && meta.duration > c.maxDuration) {
                        return `video is too long (${Math.round(meta.duration)}s, max ${c.maxDuration}s)`;
                    }
                }
                if (meta.width && meta.height) {
                    if (c.minWidth && meta.width < c.minWidth) {
                        return `width must be at least ${c.minWidth}px (is ${meta.width}px)`;
                    }
                    if (c.minHeight && meta.height < c.minHeight) {
                        return `height must be at least ${c.minHeight}px (is ${meta.height}px)`;
                    }
                    const ratio = meta.width / meta.height;
                    if (c.minRatio && ratio < c.minRatio - 0.01) {
                        return `aspect ratio ${ratio.toFixed(2)} is too tall for the selected platforms`;
                    }
                    if (Number.isFinite(c.maxRatio) && ratio > c.maxRatio + 0.01) {
                        return `aspect ratio ${ratio.toFixed(2)} is too wide for the selected platforms`;
                    }
                }
                return "";
            },
            async setVideo(file) {
                if (!file || !file.type.startsWith("video/")) return;
                const c = this.videoConstraints;
                if (c.allowedTypes && !c.allowedTypes.includes(file.type)) {
                    this.failedmsg("Unsupported format", `${file.name} isn't accepted by the selected platforms. Allowed: ${this.videoFormatsLabel}.`);
                    return;
                }
                if (file.size > c.maxSizeMB * 1024 * 1024) {
                    this.failedmsg("Video too large", `${file.name} is ${this.formatBytes(file.size)}. Max ${this.sizeLabel(c.maxSizeMB)} for the selected platforms.`);
                    return;
                }
                const url = URL.createObjectURL(file);
                const meta = await this.readVideoMeta(url);
                const reason = this.checkVideoMeta(meta, c);
                if (reason) {
                    URL.revokeObjectURL(url);
                    this.failedmsg("Unsupported video", `${file.name}: ${reason}.`);
                    return;
                }
                if (this.videoPreviewUrl) URL.revokeObjectURL(this.videoPreviewUrl);
                this.form.video = file;
                this.videoPreviewUrl = url;
                this.videoMeta = meta;
            },
            // Re-check the video at publish time (platform selection may have changed).
            validateVideo() {
                if (!this.form.video) return true;
                const c = this.videoConstraints;
                if (c.allowedTypes && !c.allowedTypes.includes(this.form.video.type)) {
                    this.failedmsg("Unsupported format", `The video isn't accepted by the selected platforms. Allowed: ${this.videoFormatsLabel}.`);
                    return false;
                }
                if (this.form.video.size > c.maxSizeMB * 1024 * 1024) {
                    this.failedmsg("Video too large", `The video exceeds the ${this.sizeLabel(c.maxSizeMB)} limit for the selected platforms.`);
                    return false;
                }
                const reason = this.checkVideoMeta(this.videoMeta || {}, c);
                if (reason) {
                    this.failedmsg("Unsupported video", `The video: ${reason}.`);
                    return false;
                }
                return true;
            },
            onVideoSelected(event) {
                if (event.target.files && event.target.files.length) {
                    this.setVideo(event.target.files[0]);
                }
                event.target.value = "";
            },
            onVideoDrop(event) {
                this.videoDragOver = false;
                if (event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files.length) {
                    this.setVideo(event.dataTransfer.files[0]);
                }
            },
            removeVideo() {
                if (this.videoPreviewUrl) URL.revokeObjectURL(this.videoPreviewUrl);
                this.videoPreviewUrl = null;
                this.form.video = null;
                this.videoMeta = null;
            },

            formatBytes(bytes) {
                if (!bytes) return "0 B";
                const units = ["B", "KB", "MB", "GB"];
                const i = Math.floor(Math.log(bytes) / Math.log(1024));
                return (bytes / Math.pow(1024, i)).toFixed(1) + " " + units[i];
            },

            resetForm() {
                this.form.platforms = [];
                this.form.facebook_page_id = "";
                this.form.target_linkedin_page_id = "";
                this.form.title = "";
                this.form.description = "";
                this.form.link_url = "";
                this.form.scheduled_date = "";
                this.photoPreviews.forEach(url => URL.revokeObjectURL(url));
                this.photoPreviews = [];
                this.photoDimensions = [];
                this.form.photos = [];
                this.removeVideo();
            },
        },
        beforeDestroy() {
            this.photoPreviews.forEach(url => URL.revokeObjectURL(url));
            if (this.videoPreviewUrl) URL.revokeObjectURL(this.videoPreviewUrl);
        },
        middleware: "authentication",
    };
</script>
<template>
    <Layout>
        <div class="d-flex align-items-center justify-content-between mb-3">
            <h4 class="mb-0 d-flex align-items-center">
                <router-link to="/content/social_upload" class="text-body me-2" title="Back">
                    <i class="mdi mdi-arrow-left"></i>
                </router-link>
                Create post
            </h4>
            <a href="javascript:void(0);" class="text-muted" @click="resetForm">
                <i class="mdi mdi-eraser-variant me-1"></i>Clear
            </a>
        </div>

        <div class="row">
            <!-- Editor -->
            <div class="col-lg-8">
                <div class="card">
                    <div class="card-body">

                        <!-- Platforms -->
                        <div v-if="!connectedPlatforms.length" class="alert alert-info py-2">
                            No connected platforms yet. Connect accounts on the
                            <router-link to="/content/social_upload">Social Upload</router-link> page.
                        </div>
                        <div class="chip-row mb-3">
                            <button
                                v-for="p in visiblePlatforms"
                                :key="p.key"
                                type="button"
                                class="platform-chip"
                                :class="{ 'platform-chip--active': form.platforms.includes(p.key), 'platform-chip--off': !p.connected }"
                                :disabled="!p.connected"
                                @click="togglePlatform(p)"
                            >
                                <i :class="p.icon" class="me-1"></i>{{ p.label }}
                            </button>
                        </div>

                        <!-- Info banner -->
                        <div class="alert alert-info d-flex align-items-start py-2">
                            <i class="mdi mdi-information-outline me-2"></i>
                            <div>Text, media and links will be copied to all selected social profiles.</div>
                        </div>

                        <!-- Post type -->
                        <div class="btn-group btn-group-sm mb-3" role="group">
                            <button
                                v-for="t in postTypes"
                                :key="t.value"
                                type="button"
                                class="btn"
                                :class="postType === t.value ? 'btn-primary' : 'btn-outline-primary'"
                                @click="postType = t.value"
                            >
                                <i :class="t.icon" class="me-1"></i>{{ t.label }}
                            </button>
                        </div>

                        <!-- Facebook page -->
                        <div v-if="needsFacebookPage" class="mb-4">
                            <label class="form-label">Facebook Page <span class="text-danger">*</span></label>
                            <div v-if="loadingFacebookPages" class="text-muted">
                                <b-spinner small class="me-2"></b-spinner>Loading pages...
                            </div>
                            <select v-else v-model="form.facebook_page_id" class="form-select">
                                <option value="" disabled>Select a Facebook Page</option>
                                <option v-for="page in facebookPages" :key="page.id" :value="page.id">
                                    {{ page.name }} ({{ page.id }})
                                </option>
                            </select>
                            <small v-if="!loadingFacebookPages && !facebookPages.length" class="text-muted">
                                No Facebook Pages found for this profile.
                            </small>
                        </div>

                        <!-- LinkedIn page (optional) -->
                        <div v-if="needsLinkedinPage" class="mb-4">
                            <label class="form-label">LinkedIn Page</label>
                            <div v-if="loadingLinkedinPages" class="text-muted">
                                <b-spinner small class="me-2"></b-spinner>Loading pages...
                            </div>
                            <select v-else v-model="form.target_linkedin_page_id" class="form-select">
                                <option value="">Post to my personal profile</option>
                                <option v-for="page in linkedinPages" :key="page.id" :value="page.id">
                                    {{ page.name }} ({{ page.id }})
                                </option>
                            </select>
                            <small class="text-muted">
                                Leave empty to post to your personal profile. Select a page to post to an organization.
                            </small>
                        </div>

                        <!-- Content -->
                        <div class="mb-3">
                            <label class="form-label">
                                Content
                                <span v-if="postType === 'text'" class="text-danger">*</span>
                            </label>
                            <b-form-textarea
                                v-model="form.title"
                                rows="4"
                                placeholder="Write your post content..."
                            ></b-form-textarea>
                            <div class="text-end text-muted font-size-12 mt-1">
                                {{ (form.title || "").length }} characters
                            </div>
                            <div v-if="facebookVideoCaption" class="alert alert-warning py-2 mt-2 mb-0">
                                <i class="mdi mdi-facebook me-1"></i>
                                On <strong>Facebook</strong>, video posts are published as Reels — the
                                <strong>Description</strong> below becomes the post caption, not this Content.
                            </div>
                        </div>

                        <!-- Description (only when a platform that uses it is selected) -->
                        <div v-if="showDescription" class="mb-3">
                            <label class="form-label">Description</label>
                            <b-form-textarea
                                v-model="form.description"
                                rows="2"
                                placeholder="Optional additional description..."
                            ></b-form-textarea>
                            <small class="text-muted">{{ descriptionHint }}</small>
                        </div>

                        <!-- Link (text only) -->
                        <div v-if="postType === 'text'" class="mb-3">
                            <label class="form-label">Link URL</label>
                            <b-form-input
                                v-model="form.link_url"
                                type="url"
                                placeholder="https://example.com"
                            ></b-form-input>
                        </div>

                        <!-- Photos -->
                        <div v-if="postType === 'photos'" class="mb-3">
                            <label class="form-label">Photos <span class="text-danger">*</span></label>

                            <div v-if="photoRequirements.length" class="alert alert-info py-2">
                                <div class="fw-semibold mb-1">
                                    <i class="mdi mdi-information-outline me-1"></i>Photo requirements for the selected platforms
                                </div>
                                <ul class="mb-0 ps-3">
                                    <li v-for="r in photoRequirements" :key="r.platform">
                                        <i :class="platformIcon(r.platform)" class="me-1"></i><strong>{{ r.label }}:</strong> {{ r.display }}
                                    </li>
                                </ul>
                            </div>

                            <div
                                class="upload-zone"
                                :class="{ 'upload-zone--active': photoDragOver }"
                                @click="triggerInput('photoInput')"
                                @dragover.prevent="photoDragOver = true"
                                @dragleave.prevent="photoDragOver = false"
                                @drop.prevent="onPhotosDrop"
                            >
                                <input
                                    ref="photoInput"
                                    type="file"
                                    class="d-none"
                                    multiple
                                    :accept="photoAccept"
                                    @change="onPhotosSelected"
                                />
                                <div class="upload-zone__icon"><i class="mdi mdi-image-multiple-outline"></i></div>
                                <div class="upload-zone__title">Drag &amp; drop images here</div>
                                <div class="upload-zone__hint">
                                    or <span class="text-primary fw-semibold">browse</span> to choose files · {{ photoHint }}
                                </div>
                            </div>

                            <div v-if="photoPreviews.length" class="upload-grid mt-3">
                                <div v-for="(url, index) in photoPreviews" :key="index" class="upload-thumb">
                                    <img :src="url" alt="preview" />
                                    <button type="button" class="upload-thumb__remove" @click.stop="removePhoto(index)">
                                        <i class="mdi mdi-close"></i>
                                    </button>
                                    <div class="upload-thumb__meta">{{ formatBytes(form.photos[index].size) }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Video -->
                        <div v-if="postType === 'video'" class="mb-3">
                            <label class="form-label">Video <span class="text-danger">*</span></label>

                            <div v-if="videoRequirements.length" class="alert alert-info py-2">
                                <div class="fw-semibold mb-1">
                                    <i class="mdi mdi-information-outline me-1"></i>Video requirements for the selected platforms
                                </div>
                                <ul class="mb-0 ps-3">
                                    <li v-for="r in videoRequirements" :key="r.platform">
                                        <i :class="platformIcon(r.platform)" class="me-1"></i><strong>{{ r.label }}:</strong> {{ r.display }}
                                    </li>
                                </ul>
                            </div>

                            <div
                                v-if="!form.video"
                                class="upload-zone"
                                :class="{ 'upload-zone--active': videoDragOver }"
                                @click="triggerInput('videoInput')"
                                @dragover.prevent="videoDragOver = true"
                                @dragleave.prevent="videoDragOver = false"
                                @drop.prevent="onVideoDrop"
                            >
                                <input
                                    ref="videoInput"
                                    type="file"
                                    class="d-none"
                                    :accept="videoAccept"
                                    @change="onVideoSelected"
                                />
                                <div class="upload-zone__icon"><i class="mdi mdi-movie-open-outline"></i></div>
                                <div class="upload-zone__title">Drag &amp; drop a video here</div>
                                <div class="upload-zone__hint">
                                    or <span class="text-primary fw-semibold">browse</span> to choose a file · {{ videoHint }}
                                </div>
                            </div>

                            <div v-else class="upload-video-card">
                                <video :src="videoPreviewUrl" class="upload-video-card__player" controls></video>
                                <div class="upload-video-card__info">
                                    <div class="upload-video-card__name text-truncate">
                                        <i class="mdi mdi-movie-outline me-2"></i>{{ form.video.name }}
                                    </div>
                                    <div class="upload-video-card__meta">{{ formatBytes(form.video.size) }}</div>
                                    <button type="button" class="btn btn-sm btn-outline-danger mt-2" @click="removeVideo">
                                        <i class="mdi mdi-delete-outline me-1"></i>Remove
                                    </button>
                                </div>
                            </div>
                        </div>

                        <!-- Schedule type -->
                        <div class="card border mt-2 mb-0">
                            <div class="card-body py-3">
                                <div class="fw-semibold mb-2">
                                    <i class="mdi mdi-clock-outline me-1"></i>Select schedule type
                                </div>
                                <b-form-radio v-model="scheduleType" name="schedule" value="immediately" class="mb-2">
                                    <span class="ms-2">Immediately</span>
                                </b-form-radio>
                                <b-form-radio v-model="scheduleType" name="schedule" value="custom">
                                    <span class="ms-2">Custom time</span>
                                </b-form-radio>
                                <div v-if="scheduleType === 'custom'" class="mt-2">
                                    <b-form-input v-model="form.scheduled_date" type="datetime-local"></b-form-input>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- Post preview -->
            <div class="col-lg-4">
                <div class="card">
                    <div class="card-body">
                        <h5 class="mb-0">Post Preview</h5>
                        <p class="text-muted font-size-12 mb-3">Social networks may alter formatting</p>

                        <div v-if="loadingSocialAccounts" class="text-muted py-4 text-center">
                            <b-spinner small class="me-2"></b-spinner>Loading platforms...
                        </div>
                        <div v-else-if="!previewPlatforms.length" class="alert alert-info py-2 mb-0">
                            No connected platforms to preview. Connect accounts on the
                            <router-link to="/content/social_upload">Social Upload</router-link> page.
                        </div>
                        <template v-else>
                            <!-- Platform tabs -->
                            <div class="preview-tabs">
                                <button
                                    v-for="p in previewPlatforms"
                                    :key="p.key"
                                    type="button"
                                    class="preview-tab"
                                    :class="{ 'preview-tab--active': previewPlatform === p.key }"
                                    @click="previewPlatform = p.key"
                                >{{ p.label }}</button>
                            </div>

                            <!-- Instagram -->
                            <div v-if="previewPlatform === 'instagram'" class="pv-card">
                                <div class="pv-head">
                                    <span class="pv-avatar pv-avatar--ig">{{ avatarInitials }}</span>
                                    <span class="pv-user">{{ handle }}</span>
                                    <i class="mdi mdi-dots-horizontal ms-auto text-muted"></i>
                                </div>
                                <div class="pv-media pv-media--ig">
                                    <img v-if="previewImageUrl" :src="previewImageUrl" alt="" />
                                    <video v-else-if="previewVideoUrl" :key="previewVideoUrl" :src="previewVideoUrl" controls preload="metadata"></video>
                                    <span v-else class="pv-media-empty">No media added</span>
                                </div>
                                <div class="pv-ig-actions">
                                    <i class="mdi mdi-heart-outline"></i>
                                    <i class="mdi mdi-comment-outline"></i>
                                    <i class="mdi mdi-send-outline"></i>
                                    <i class="mdi mdi-bookmark-outline ms-auto"></i>
                                </div>
                                <div class="pv-ig-likes">1,204 likes</div>
                                <div class="pv-ig-caption"><strong>{{ handle }}</strong> {{ captionText }}</div>
                            </div>

                            <!-- X (Twitter) -->
                            <div v-else-if="previewPlatform === 'x'" class="pv-card pv-card--pad">
                                <div class="d-flex">
                                    <span class="pv-avatar pv-avatar--x">{{ avatarInitials }}</span>
                                    <div class="ms-2 flex-grow-1 min-w-0">
                                        <div class="pv-x-name">
                                            <strong>{{ profileName }}</strong>
                                            <span class="text-muted"> @{{ handle }} · now</span>
                                        </div>
                                        <div class="pv-body-text">{{ captionText }}</div>
                                        <div v-if="previewImageUrl || previewVideoUrl" class="pv-media pv-media--x">
                                            <img v-if="previewImageUrl" :src="previewImageUrl" alt="" />
                                            <video v-else :key="previewVideoUrl" :src="previewVideoUrl" controls preload="metadata"></video>
                                        </div>
                                        <div class="pv-x-actions">
                                            <span><i class="mdi mdi-comment-outline"></i> 12</span>
                                            <span><i class="mdi mdi-repeat-variant"></i> 34</span>
                                            <span><i class="mdi mdi-heart-outline"></i> 208</span>
                                            <span><i class="mdi mdi-chart-bar"></i> 5.6K</span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- Facebook -->
                            <div v-else-if="previewPlatform === 'facebook'" class="pv-card">
                                <div class="pv-head">
                                    <span class="pv-avatar pv-avatar--fb">{{ avatarInitials }}</span>
                                    <div class="min-w-0">
                                        <div class="fw-semibold">{{ profileName }}</div>
                                        <div class="text-muted pv-sub">Just now · <i class="mdi mdi-earth"></i></div>
                                    </div>
                                    <i class="mdi mdi-dots-horizontal ms-auto text-muted"></i>
                                </div>
                                <div class="pv-body-text px-2 pb-2">{{ captionText }}</div>
                                <div v-if="previewImageUrl || previewVideoUrl" class="pv-media pv-media--fb">
                                    <img v-if="previewImageUrl" :src="previewImageUrl" alt="" />
                                    <video v-else :key="previewVideoUrl" :src="previewVideoUrl" controls preload="metadata"></video>
                                </div>
                                <div class="pv-fb-actions">
                                    <span><i class="mdi mdi-thumb-up-outline"></i> Like</span>
                                    <span><i class="mdi mdi-comment-outline"></i> Comment</span>
                                    <span><i class="mdi mdi-share-outline"></i> Share</span>
                                </div>
                            </div>

                            <!-- TikTok -->
                            <div v-else-if="previewPlatform === 'tiktok'" class="pv-card pv-tt">
                                <div class="pv-media pv-media--tt">
                                    <img v-if="previewImageUrl" :src="previewImageUrl" alt="" />
                                    <video v-else-if="previewVideoUrl" :key="previewVideoUrl" :src="previewVideoUrl" controls preload="metadata"></video>
                                    <span v-else class="pv-media-empty">No media added</span>
                                    <div class="pv-tt-rail">
                                        <span class="pv-avatar pv-avatar--tt">{{ avatarInitials }}</span>
                                        <span class="pv-tt-btn"><i class="mdi mdi-heart"></i><small>1.2K</small></span>
                                        <span class="pv-tt-btn"><i class="mdi mdi-comment"></i><small>84</small></span>
                                        <span class="pv-tt-btn"><i class="mdi mdi-share"></i><small>Share</small></span>
                                    </div>
                                    <div class="pv-tt-caption">
                                        <div class="fw-semibold">@{{ handle }}</div>
                                        <div class="pv-tt-text">{{ captionText }}</div>
                                    </div>
                                </div>
                            </div>

                            <!-- YouTube -->
                            <div v-else-if="previewPlatform === 'youtube'" class="pv-card">
                                <div class="pv-media pv-media--yt">
                                    <video v-if="previewVideoUrl" :key="previewVideoUrl" :src="previewVideoUrl" controls preload="metadata"></video>
                                    <span v-else class="pv-media-empty">No media added</span>
                                </div>
                                <div class="pv-yt-meta">
                                    <span class="pv-avatar pv-avatar--yt">{{ avatarInitials }}</span>
                                    <div class="min-w-0">
                                        <div class="pv-yt-title">{{ captionText }}</div>
                                        <div class="text-muted pv-sub">{{ profileName }} · Just now</div>
                                    </div>
                                </div>
                            </div>

                            <!-- Generic fallback -->
                            <div v-else class="pv-card">
                                <div class="pv-head">
                                    <span class="pv-avatar">{{ avatarInitials }}</span>
                                    <span class="pv-user">{{ profileName }}</span>
                                </div>
                                <div v-if="previewImageUrl || previewVideoUrl" class="pv-media pv-media--fb">
                                    <img v-if="previewImageUrl" :src="previewImageUrl" alt="" />
                                    <video v-else :key="previewVideoUrl" :src="previewVideoUrl" controls preload="metadata"></video>
                                </div>
                                <div class="pv-body-text p-2">{{ captionText }}</div>
                            </div>

                            <p class="text-muted font-size-12 mt-3 mb-0">
                                <i class="mdi mdi-circle-small"></i>
                                <template v-if="scheduleType === 'custom' && form.scheduled_date">
                                    This post will be published automatically at your scheduled time
                                </template>
                                <template v-else>
                                    This post will be published immediately
                                </template>
                            </p>
                        </template>
                    </div>
                </div>
            </div>
        </div>

        <!-- Sticky action footer -->
        <div class="composer-footer d-flex align-items-center justify-content-between">
            <span class="text-muted">
                <i class="mdi mdi-check-circle-outline me-1"></i>{{ form.platforms.length }} platform(s) selected
            </span>
            <div>
                <button type="button" class="btn btn-primary" :disabled="isPublishing" @click="publish">
                    <span v-if="!isPublishing"><i class="mdi mdi-send me-1"></i>Publish Now</span>
                    <span v-else>Publishing...</span>
                </button>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
    /* Platform chips */
    .chip-row {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem;
    }
    .platform-chip {
        display: inline-flex;
        align-items: center;
        border: 1px solid #ced4da;
        background: #fff;
        color: #495057;
        border-radius: 999px;
        padding: 0.35rem 0.85rem;
        font-size: 0.8125rem;
        transition: all 0.15s ease;
    }
    .platform-chip:hover:not(.platform-chip--off) {
        border-color: #556ee6;
        color: #556ee6;
    }
    .platform-chip--active {
        border-color: #556ee6;
        background: #eef1ff;
        color: #556ee6;
        font-weight: 600;
    }
    .platform-chip--off {
        opacity: 0.5;
        cursor: not-allowed;
    }

    /* Sticky action footer */
    .composer-footer {
        position: sticky;
        bottom: 0;
        background: #fff;
        border-top: 1px solid #eff2f7;
        padding: 0.75rem 0.25rem;
        margin-top: 1rem;
        z-index: 5;
    }

    .min-w-0 { min-width: 0; }

    /* ── Preview: platform tabs ─────────────────────────────────────────────── */
    .preview-tabs {
        display: flex;
        gap: 0.25rem;
        overflow-x: auto;
        border-bottom: 1px solid #eff2f7;
        margin-bottom: 0.85rem;
        padding-bottom: 0.35rem;
    }
    .preview-tab {
        flex: 0 0 auto;
        border: none;
        background: transparent;
        color: #74788d;
        font-size: 0.8125rem;
        font-weight: 500;
        padding: 0.35rem 0.75rem;
        border-radius: 0.5rem;
        white-space: nowrap;
        transition: all 0.15s ease;
    }
    .preview-tab:hover { color: #556ee6; }
    .preview-tab--active {
        background: #eef1ff;
        color: #556ee6;
        font-weight: 600;
    }

    /* ── Preview: shared card ───────────────────────────────────────────────── */
    .pv-card {
        border: 1px solid #eff2f7;
        border-radius: 0.65rem;
        overflow: hidden;
        background: #fff;
        box-shadow: 0 1px 4px rgba(18, 38, 63, 0.06);
    }
    .pv-card--pad { padding: 0.85rem; }

    .pv-head {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        padding: 0.6rem 0.75rem;
    }
    .pv-avatar {
        width: 34px;
        height: 34px;
        border-radius: 50%;
        flex: 0 0 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #556ee6;
        color: #fff;
        font-weight: 600;
        font-size: 12px;
    }
    .pv-avatar--ig { background: radial-gradient(circle at 30% 107%, #fdf497 0%, #fd5949 45%, #d6249f 60%, #285AEB 90%); }
    .pv-avatar--x  { background: #0f1419; }
    .pv-avatar--fb { background: #1877F2; }
    .pv-avatar--tt { background: #111; border: 1px solid #fff; }
    .pv-avatar--yt { background: #FF0000; }
    .pv-user { font-weight: 600; font-size: 0.875rem; }
    .pv-sub { font-size: 0.75rem; }

    .pv-media {
        position: relative;
        width: 100%;
        background: #f0f0f3;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
    }
    .pv-media video,
    .pv-media img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        display: block;
        background: #000;
    }
    .pv-media-empty {
        color: #adb5bd;
        font-size: 0.9rem;
        padding: 3rem 0;
    }
    .pv-media--ig { aspect-ratio: 4 / 5; }
    .pv-media--x  { aspect-ratio: 16 / 9; border-radius: 0.75rem; margin-top: 0.5rem; }
    .pv-media--fb { aspect-ratio: 1 / 1; }
    .pv-media--yt { aspect-ratio: 16 / 9; background: #000; }
    .pv-media--tt { aspect-ratio: 9 / 16; max-height: 480px; background: #000; }

    .pv-body-text {
        white-space: pre-wrap;
        color: #1c1e21;
        font-size: 0.875rem;
    }

    /* Instagram */
    .pv-ig-actions {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        font-size: 1.35rem;
        color: #1c1e21;
        padding: 0.5rem 0.75rem 0.25rem;
    }
    .pv-ig-likes { font-weight: 600; font-size: 0.85rem; padding: 0 0.75rem; }
    .pv-ig-caption {
        font-size: 0.85rem;
        color: #1c1e21;
        padding: 0.25rem 0.75rem 0.85rem;
        white-space: pre-wrap;
    }

    /* X (Twitter) */
    .pv-x-name { font-size: 0.875rem; }
    .pv-x-actions {
        display: flex;
        justify-content: space-between;
        max-width: 260px;
        margin-top: 0.6rem;
        color: #536471;
        font-size: 0.8rem;
    }

    /* Facebook */
    .pv-fb-actions {
        display: flex;
        justify-content: space-around;
        border-top: 1px solid #eff2f7;
        padding: 0.5rem 0;
        color: #65676b;
        font-size: 0.85rem;
        font-weight: 500;
    }

    /* TikTok */
    .pv-tt .pv-media--tt { border-radius: 0.65rem; }
    .pv-tt-rail {
        position: absolute;
        right: 8px;
        bottom: 70px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 1rem;
        color: #fff;
    }
    .pv-tt-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
        font-size: 1.5rem;
        line-height: 1;
    }
    .pv-tt-btn small { font-size: 0.7rem; margin-top: 2px; }
    .pv-tt-caption {
        position: absolute;
        left: 10px;
        right: 60px;
        bottom: 12px;
        color: #fff;
        font-size: 0.8rem;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
    }
    .pv-tt-text { white-space: pre-wrap; }

    /* YouTube */
    .pv-yt-meta {
        display: flex;
        align-items: flex-start;
        gap: 0.5rem;
        padding: 0.6rem 0.75rem;
    }
    .pv-yt-title {
        font-weight: 600;
        font-size: 0.875rem;
        color: #0f0f0f;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .account-avatar {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        overflow: hidden;
        flex: 0 0 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f3f5ff;
        color: #556ee6;
        font-size: 18px;
    }
    .account-avatar img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    .font-size-11 {
        font-size: 11px;
    }
    .composer-header .mdi {
        font-size: 1.5rem;
        color: #74788d;
    }

    .upload-zone {
        border: 2px dashed #ced4da;
        border-radius: 0.75rem;
        padding: 2.5rem 1.5rem;
        text-align: center;
        cursor: pointer;
        background: #f8f9fc;
        transition: border-color 0.2s ease, background 0.2s ease, box-shadow 0.2s ease;
    }
    .upload-zone:hover {
        border-color: #556ee6;
        background: #f3f5ff;
    }
    .upload-zone--active {
        border-color: #556ee6;
        background: #eef1ff;
        box-shadow: 0 0 0 4px rgba(85, 110, 230, 0.12);
    }
    .upload-zone__icon {
        font-size: 2.75rem;
        line-height: 1;
        color: #556ee6;
        margin-bottom: 0.5rem;
    }
    .upload-zone__title {
        font-weight: 600;
        color: #495057;
    }
    .upload-zone__hint {
        font-size: 0.8125rem;
        color: #74788d;
        margin-top: 0.25rem;
    }

    .upload-grid {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
        gap: 0.75rem;
    }
    .upload-thumb {
        position: relative;
        border-radius: 0.5rem;
        overflow: hidden;
        aspect-ratio: 1 / 1;
        background: #000;
        box-shadow: 0 1px 4px rgba(18, 38, 63, 0.12);
    }
    .upload-thumb img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
    }
    .upload-thumb__remove {
        position: absolute;
        top: 6px;
        right: 6px;
        width: 24px;
        height: 24px;
        border: none;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.55);
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        cursor: pointer;
        transition: background 0.15s ease;
    }
    .upload-thumb__remove:hover {
        background: #f46a6a;
    }
    .upload-thumb__meta {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 2px 6px;
        font-size: 0.7rem;
        color: #fff;
        background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
    }

    .upload-video-card {
        display: flex;
        gap: 1rem;
        padding: 0.75rem;
        border: 1px solid #eff2f7;
        border-radius: 0.75rem;
        background: #fff;
        box-shadow: 0 1px 4px rgba(18, 38, 63, 0.08);
    }
    .upload-video-card__player {
        width: 220px;
        max-width: 45%;
        border-radius: 0.5rem;
        background: #000;
    }
    .upload-video-card__info {
        flex: 1;
        min-width: 0;
    }
    .upload-video-card__name {
        font-weight: 600;
        color: #495057;
    }
    .upload-video-card__meta {
        font-size: 0.8125rem;
        color: #74788d;
    }
</style>
